module.exports = __webpack_public_path__ + "static/media/reveal.ea27546c.jpg";